import { render, staticRenderFns } from "./CountAuditsPlannedAndDone.vue?vue&type=template&id=63108641&scoped=true&"
import script from "./CountAuditsPlannedAndDone.vue?vue&type=script&lang=ts&"
export * from "./CountAuditsPlannedAndDone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63108641",
  null
  
)

export default component.exports